import Modal from '../../../shared/Modal'
import TextInput from '../../../shared/Inputs/TextInput'
import { useState } from 'react'
import useHttpLoader from '../../../hooks/useHttpLoader'
import packsService from '../../../services/packs/packs.service'
import { IPack } from '../../../services/packs/packs.types'
import NbmgButton from '../../../shared/NbmgButton'

interface IProps {
  onCreate: (pack: IPack) => void
  onClose: () => void
}

const CreateVersionModal = (props: IProps) => {
  const { loading, wait } = useHttpLoader()
  const [pack, setPack] = useState({ name: '', version: '' })

  const handleChange = (value: any, name: string) => setPack((prev) => ({ ...prev, [name]: value }))

  const handleCreate = () => {
    wait(packsService.createPack({ name: pack.name } as any), (resp) => {
      props.onCreate(resp)
    })
  }

  return (
    <Modal onClose={props.onClose}>
      <div className="flex-form">
        <h2 className="form-header" style={{ textAlign: 'center' }}>
          Создать версию
        </h2>
        <TextInput value={pack.name} name="name" onChange={handleChange} placeHolder="Имя" />
        <TextInput value={pack.version} name="version" onChange={handleChange} placeHolder="Номер" />
        <div className="form-footer">
          <NbmgButton loading={loading} onClick={handleCreate} withHands={true} disabled={!pack.name}>
            Создать
          </NbmgButton>
        </div>
      </div>
    </Modal>
  )
}

export default CreateVersionModal
